import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { MatButtonModule } from '@angular/material/button';
import { SavingStatus } from '../../../../tokens-and-interfaces';

@Component({
  selector: 'crm-form-button-group',
  template: `
    <div class="crm-buttons">
      <button
        (click)="this.clickedOnSubmit.emit()"
        mat-flat-button
        [disabled]="savingStatus === SavingStatus.SAVING"
        color="primary"
        type="button"
        data-testid="submit-button"
      >
        <glxy-button-loading-indicator [isLoading]="savingStatus === SavingStatus.SAVING">
          {{ submitButtonText | translate }}
        </glxy-button-loading-indicator>
      </button>
      <button
        (click)="this.clickedOnCancel.emit()"
        mat-stroked-button
        [disabled]="savingStatus === SavingStatus.SAVING"
        type="button"
        data-testid="cancel-button"
      >
        {{ cancelButtonText | translate }}
      </button>
    </div>
  `,
  styleUrls: ['./form-button-group.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyEmptyStateModule,
    MatIconModule,
    GalaxyLoadingSpinnerModule,
    GalaxyButtonLoadingIndicatorModule,
    MatButtonModule,
  ],
})
export class CrmFormButtonGroupComponent {
  @Input() submitButtonText = '';
  @Input() cancelButtonText = '';
  @Input() savingStatus!: SavingStatus;

  @Output() clickedOnSubmit = new EventEmitter();
  @Output() clickedOnCancel = new EventEmitter();

  SavingStatus = SavingStatus;
}
